<script>
import ListingFilterSelect from './ListingFilterSelect.vue';

export default {
    data() {
        return {
            currentFilters: []
        }
    }
}
</script>